import { Component, Input, ViewChild } from '@angular/core'
import { IDataCardWorkOrder } from '../../../../../../models/data-card.model'
import { NzDrawerService } from 'ng-zorro-antd/drawer'
import { MainObjectDataCardTemplateComponent } from '../../../main-object-data-card-template/main-object-data-card-template.component'
import { NgbNav } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-data-work-order',
    templateUrl: './data-work-order.component.html',
    styleUrl: './data-work-order.component.scss',
    standalone: false
})
export class DataWorkOrderComponent {
  @ViewChild('nav') private nav: NgbNav

  @Input() data: IDataCardWorkOrder
  @Input() isLoading: boolean = false

  public constructor(private drawerService: NzDrawerService) {}

  public onDataCardDrawerOpen(mainObject: string): void {
    this.drawerService.create<MainObjectDataCardTemplateComponent, { mo: string }, any>({
      nzTitle: 'Datacard',
      nzWidth: '500px',
      nzContent: MainObjectDataCardTemplateComponent,
      nzData: { mo: mainObject },
    })
  }
}
